import { createTheme } from "@mui/material/styles";
import themes from "./themes";

export default createTheme(themes.defaultObject);
